import React from 'react';

import { WizardBreadcrumbItem } from './wizardLogic';

export interface WizardBreadcrumbsProps {
  readonly items: readonly WizardBreadcrumbItem[];
  readonly onStepClick?: (stepId: WizardBreadcrumbItem['stepId']) => void;
}

function WizardBreadcrumbs({
  items,
  onStepClick,
}: WizardBreadcrumbsProps): JSX.Element {
  return (
    <nav
      className="sdm-add-layer-wizard__breadcrumbs"
      aria-label="Layer configuration selections"
    >
      <ol className="sdm-add-layer-wizard__breadcrumb-list">
        {items.map((item, index) => (
          <li
            key={item.stepId}
            className={`sdm-add-layer-wizard__breadcrumb-item${
              item.isCurrent ? ' sdm-add-layer-wizard__breadcrumb-item--current' : ''
            }${item.isComplete ? ' sdm-add-layer-wizard__breadcrumb-item--complete' : ''}`}
          >
            {index > 0 ? (
              <span
                className="sdm-add-layer-wizard__breadcrumb-separator"
                aria-hidden
              >
                /
              </span>
            ) : null}
            {item.canNavigate && onStepClick ? (
              <button
                type="button"
                className="sdm-add-layer-wizard__breadcrumb-crumb sdm-add-layer-wizard__breadcrumb-crumb--clickable"
                onClick={() => onStepClick(item.stepId)}
                aria-current={item.isCurrent ? 'step' : undefined}
              >
                <span className="sdm-add-layer-wizard__breadcrumb-step">
                  {item.stepName}
                </span>
                <span className="sdm-add-layer-wizard__breadcrumb-value">
                  {item.selectionLabel}
                </span>
              </button>
            ) : (
              <span
                className="sdm-add-layer-wizard__breadcrumb-crumb"
                aria-current={item.isCurrent ? 'step' : undefined}
              >
                <span className="sdm-add-layer-wizard__breadcrumb-step">
                  {item.stepName}
                </span>
                <span
                  className={`sdm-add-layer-wizard__breadcrumb-value${
                    item.selectionLabel
                      ? ''
                      : ' sdm-add-layer-wizard__breadcrumb-value--pending'
                  }`}
                >
                  {item.selectionLabel ??
                    (item.isCurrent ? 'Selecting…' : '—')}
                </span>
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default WizardBreadcrumbs;
